import { getConfig } from '@fec/assets/js/utils/config.js';

const { IL_BASE_URL } = getConfig();

/** Merge default configuration with the given portal, or search over all portal if 'all' are specified */
export default function createConfig(
  initialConfig,
  configName,
  defaultPortalValue = '',
  businessUnit = 'srf',
) {
  // if a "root" section exists in the config, the following defaults are used.
  // an active search must at least explicitly override the "active" property to enable a search.
  let defaultOptions = {
    filters: [],
    algoliaSearch: {
      active: false,
      hideBackToTop: false,
      hitsPerPage: 20,
    },
    playSearch: {
      active: false,
      endpoint: `${IL_BASE_URL}/integrationlayer/2.0/`,
      link:
        businessUnit === 'rtr'
          ? 'https://www.rtr.ch/play/retschertga'
          : 'https://www.srf.ch/play/suche',
    },
    domainSearch: {
      active: false,
      endpoint: '/search/landingpages',
    },
    audioSearch: {
      active: false,
      bu: businessUnit,
      link: businessUnit === 'rtr' ? '/radio' : '/audio',
      endpointMedia:
        businessUnit === 'rtr'
          ? '/integrationlayer/2.0/rtr/searchResultMediaList'
          : '/integrationlayer/2.0/srf/searchResultMediaList',
      endpointShow:
        businessUnit === 'rtr'
          ? '/integrationlayer/2.0/rtr/searchResultShowList'
          : '/integrationlayer/2.0/srf/searchResultShowList',
    },
    locale: 'de-CH',
    businessUnit: businessUnit,
  };

  let newConfig = initialConfig[configName];
  newConfig = initDefaults(newConfig, defaultOptions);
  newConfig = initFilters(newConfig);
  newConfig = setPortal(newConfig, defaultPortalValue);
  newConfig.name = configName;
  return newConfig;
}

/**
 *  Adds default property and value if not already set recursively
 *  @param config object to add defaults
 *  @param defaults object
 *  @return config with default values set
 **/
function initDefaults(config, defaults) {
  let keys = Object.keys(defaults);
  keys.forEach((key) => {
    if (typeof defaults[key] === 'object' && !Array.isArray(defaults[key])) {
      config[key] = initDefaults(config[key] ? config[key] : {}, defaults[key]);
    }
    if (!(key in config)) {
      config[key] = defaults[key]; // scalar | array; use default value
    }
  });

  return config;
}

/**
 * @param config
 * @returns {*}
 */
function initFilters(config) {
  config.filters = config.filters ? config.filters : [];
  let filters = config.filters.map((el) => {
    el.hidden = 'hidden' in el ? el.hidden == true : false;
    return el;
  });
  config.filters = filters;
  return config;
}

/**
 * Adds a portalFilter to the config if needed. config.portalName is set to the option of the filter.
 * @param config
 * @param defaultPortalValue
 * @returns config with portal filter and portalName set
 */
function setPortal(config, defaultPortalValue) {
  let portalFilter = config.filters.find((el) => el.name === 'portal');
  // never override an existing defined portal filter in config.
  if (portalFilter) {
    config.portalName = portalFilter.selectedOption
      ? portalFilter.selectedOption
      : 'all';
    return config;
  }

  let portal = defaultPortalValue;
  // all means no restrictions => no filter must be set
  if (portal && portal !== 'all') {
    config.filters.push({
      name: 'portal',
      hidden: true,
      selectedOption: defaultPortalValue,
    });
    config.portalName = defaultPortalValue;
  } else {
    config.portalName = 'all'; // no portal filter restrictions
  }

  return config;
}
